import React from 'react';
import './MetricCard.css';

const MetricCard = ({ title, value, change, isPositive }) => {
    return (
        <div className="metric-card">
            <div className="card-header">
                <span className="card-title">{title}</span>
                <span className={`card-diff ${isPositive ? 'positive' : 'negative'}`}>
                    {change}
                </span>
            </div>
            <div className="card-value">{value}</div>
        </div>
    );
};

export default MetricCard;